<template>
  <div class="class-tournament p-0">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <!-- Shared player tag portal for this page -->
    <SharedPlayerTagPortal @onToggleParticipate="toggleRoundsParticipated" />

    <section class="px-4" v-if="!isLoading">
      <b-tabs type="is-boxed" expanded>
        <!-- Rounds -->
        <b-tab-item
          :label="`Rounds ${tournament.currentRound}/${tournament.totalRounds}`"
          icon="list"
        >
          <TournamentRounds
            v-if="tournament && tournament.id"
            :tournament="tournament"
            :rounds="rounds"
            :games="games"
            :players="players"
            @onTournamentStartTimeChanged="changeTournamentStartTime"
            @onScheduleRounds="scheduleRounds"
            @onRoundStartTimeChanged="changeRoundStartTime"
            @onRoundStartTimePushed="pushRoundStartTime"
            @onStart="startRound"
            @onFinish="finishRound"
            @onUnfinish="unfinishRound"
            @onPair="pairRound"
            @onSave="saveRound"
          ></TournamentRounds>
        </b-tab-item>

        <!-- Tournament -->
        <b-tab-item
          :label="tournament ? tournament.name : 'Tournament'"
          icon="edit"
        >
          <TournamentForm
            :tournament="tournament"
            @onUpdate="updateTournament"
          />
        </b-tab-item>

        <!-- Players -->
        <b-tab-item label="Players" icon="users">
          <TournamentPlayers
            :tournament="tournament"
            :players="sortedPlayers"
          />
        </b-tab-item>
      </b-tabs>
    </section>
  </div>
</template>

<script>
import { firestore, functions } from "@/services/firebase";
import TournamentRounds from "@/components/admins/tournaments/TournamentRounds.vue";
import TournamentCommonData from "@/components/admins/tournaments/TournamentCommonData.js";
import { createWithManager } from "@/components/admins/tournaments/TournamentManagerClientFactory.js";
import TournamentPlayers from "@/components/admins/tournaments/TournamentPlayers.vue";
import TournamentForm from "@/components/admins/tournaments/offline/ClassTournamentForm.vue";
import SharedPlayerTagPortal from "@/components/admins/SharedPlayerTagPortal.vue";
import { TournamentManagerFactory } from "vue-chess-shared/tournament/TournamentManagerFactory";

const handleBBPPair = functions.httpsCallable("tournament-handleBBPPair");
const tournamentManager = TournamentManagerFactory.createForOfflineClass(
  firestore,
  async (data) => (await handleBBPPair(data))?.data
);
const TournamentManagerClient = createWithManager(tournamentManager);

export default {
  components: {
    SharedPlayerTagPortal,
    TournamentRounds,
    TournamentPlayers,
    TournamentForm,
  },

  name: "OfflineClassTournament",

  title: "Offline Class Tournament",

  data() {
    return {
      isPlayersModalActive: false,
      tournament: null,
      players: [],
      rounds: [],
      games: [],
    };
  },

  mixins: [TournamentCommonData, TournamentManagerClient],

  watch: {},

  computed: {},

  methods: {
    async updateTournament(tournamentId, tournamentData) {
      await tournamentManager.updateTournament(tournamentId, {
        ...tournamentData,
        updatedAt: new Date(),
      });
      this.$buefy.toast.open({
        message: "Update successfully",
        type: "is-success",
      });
    },
  },

  async created() {
    this.tournamentId = this.$route.params.id;

    const tournamentRef = firestore
      .collection("classTournaments")
      .doc(this.tournamentId);

    const roundsRef = tournamentRef.collection("rounds");
    const gamesRef = tournamentRef.collection("games");
    const playersRef = tournamentRef.collection("players");

    await this.$bind("tournament", tournamentRef);
    await this.$bind("players", playersRef);
    await this.$bind("rounds", roundsRef);
    await this.$bind("games", gamesRef);
    this.isLoading = false;
  },
};
</script>

<style scoped>
.panel-heading {
  border-radius: 0;
}
</style>
